import React from 'react';
import {
  VaAlertSignIn,
  VaButton,
} from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import {
  VerifyIdmeButton,
  VerifyLogingovButton,
} from 'platform/user/authentication/components/VerifyButton';
import { CSP_IDS } from 'platform/user/authentication/constants';
import PropTypes from 'prop-types';
import AskVaLinkWithRouter from '../AskVaLink';

/**
 * @typedef {object} UnauthenticatedUiProps
 * @property {() => void} showSignInModal
 * @property {string} [signInServiceName]
 */

/** @param {UnauthenticatedUiProps} props */
export function UnauthenticatedIntro({ showSignInModal, signInServiceName }) {
  const needsVerification = [CSP_IDS.ID_ME, CSP_IDS.LOGIN_GOV].includes(
    signInServiceName,
  );
  const isIdMe = signInServiceName === CSP_IDS.ID_ME;

  return (
    <div className="intro-unauth">
      <div>
        <h2 className="vads-u-margin-top--4">How to start</h2>
        <p>
          You can use Ask VA to ask a question online. You can ask us about
          education benefits, VA disability compensation (pay), healthcare, and
          many other topics.
        </p>
        <h3 className="vads-u-margin-top--3">
          Ask a question or read a reply from VA
        </h3>
        <p className="vads-u-margin-bottom--1">
          You need to sign in to ask a question about yourself, a family member
          or another Veteran. This form takes about 10 to 15 minutes to
          complete.
        </p>
        <p>
          Signing in also lets you track your question and read a reply from VA
          when it’s ready.
        </p>
        {needsVerification ? (
          <VaAlertSignIn
            headingLevel={4}
            variant={isIdMe ? 'verifyIdMe' : 'verifyLoginGov'}
            visible
          >
            {isIdMe ? (
              <span slot="IdMeVerifyButton">
                <VerifyIdmeButton />
              </span>
            ) : (
              <span slot="LoginGovVerifyButton">
                <VerifyLogingovButton />
              </span>
            )}
          </VaAlertSignIn>
        ) : (
          <VaAlertSignIn variant="signInRequired" visible headingLevel={4}>
            <span slot="SignInButton">
              <VaButton
                text="Sign in or create an account"
                onClick={showSignInModal}
              />
            </span>
          </VaAlertSignIn>
        )}
      </div>
    </div>
  );
}

UnauthenticatedIntro.propTypes = {
  showSignInModal: PropTypes.func.isRequired,
  signInServiceName: PropTypes.string,
};

/** @param {string} formStartLink */
export function getUnauthenticatedStartLink(formStartLink) {
  return (
    <div>
      <p>
        If you have a general question that’s not about yourself, a family
        member, or another Veteran, you can ask without signing in. This form
        takes about 2 to 5 minutes to complete.
      </p>
      <AskVaLinkWithRouter
        variant="action.secondary"
        href={formStartLink}
        text="Start your question without signing in"
      />
    </div>
  );
}
